import { render, staticRenderFns } from "./AppointmentReport.vue?vue&type=template&id=879f799e&scoped=true&"
import script from "./AppointmentReport.vue?vue&type=script&lang=js&"
export * from "./AppointmentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879f799e",
  null
  
)

export default component.exports